<template>
    <card>
        <card-header>
            <card-overline>K-Wareneingang</card-overline>
        </card-header>
        <card-content>
            <table class="table table--card table--stripped">
                <thead>
                <tr>
                    <th>Eingangsdatum</th>
                    <th>Liefermenge</th>
                    <th>Kommentar</th>
                    <th>Operator</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="incomingGoodsClient in incomingGoodsClientTable"
                    :key="incomingGoodsClient.index">
                    <td>{{ incomingGoodsClient.delivery_at_string }}</td>
                    <td>{{ incomingGoodsClient.amount }} von {{ maxIncomingQty }}</td>
                    <td>{{ incomingGoodsClient.comment }}</td>
                    <td>{{ incomingGoodsClient.admin_user.name }}</td>
                    <td>
                        <form-button type="button" class="btn--dense"
                                     @click="deleteDialog = true; deleteRoute = this.$$route('ask-for-quote.delivery.incoming-goods-client.delete', {'askForQuote': this.askForQuote, 'delivery': incomingGoodsClient.id})"
                                     icon="trash-delete-bin-2"/>
                    </td>
                </tr>
                </tbody>
            </table>
            <modal-dialog title="K-Wareneingang löschen" text="Möchten Sie den K-Wareneingang wirklich löschen?"
                          confirm="löschen" v-if="deleteDialog" @closeDialog="deleteDialog = false;"
                          @confirmDialog="deleteMethod"/>
        </card-content>
        <card-content>
            <form-button class="btn--block" color="secondary"
                         @click="incomingGoodsClientModal = !incomingGoodsClientModal"
                         icon="package-box-arrow" :disabled="disabledTab || ! hasClientComplaint">neuer Wareneingang
            </form-button>
            <incoming-goods-client-modal :ask-for-quote="askForQuote"
                                         v-if="incomingGoodsClientModal"
                                         :admin-users="adminUsers"
                                         @closeDialog="incomingGoodsClientModal = false;"/>
        </card-content>
    </card>
</template>

<script>
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardOverline from '@partfactory/Shared/Card/CardOverline';
import CardContent from '@partfactory/Shared/Card/CardContent';
import FormButton from '@partfactory/Shared/Form/FormButton';
import IncomingGoodsClientModal from '@partfactory/Pages/Admin/AskForQuote/Modals/IncomingGoodsClientModal';
import ModalDialog from '@partfactory/Shared/Modal/ModalDialog';

export default {
    name: 'IncomingGoodsClient',
    components: {
        ModalDialog, IncomingGoodsClientModal, FormButton, CardContent, CardOverline, CardHeader, Card
    },
    props: {
        askForQuote: Object,
        adminUsers: Object,
    },
    data() {
        return {
            incomingGoodsClientModal: false,
            deleteDialog: false,
            deleteRoute: null,
        };
    },
    computed: {
        maxIncomingQty() {
            let maxIncomingQty = 0;
            this.askForQuote?.client_complaints?.forEach((incoming) => {
                maxIncomingQty += incoming.amount;
            });
            return maxIncomingQty;
        },
        incomingGoodsClientTable() {
            let incomingGoodsClient = this.askForQuote?.incoming_goods_client;
            incomingGoodsClient?.forEach(incomingGoodsClient => {
                incomingGoodsClient.delivery_at_string = this.$date(incomingGoodsClient.delivery_at);

                return incomingGoodsClient;
            });
            return incomingGoodsClient;
        },
        disabledTab() {
            return this.$disabledTab(this.askForQuote.status, 99);
        },
        hasClientComplaint() {
            return this.askForQuote?.client_complaints.length > 0;
        },
    },
    methods: {
        deleteMethod() {
            this.$inertia.delete(this.deleteRoute);
            this.deleteRoute = null;
            this.deleteDialog = false;
        },
    },
};
</script>
